import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from "@react-oauth/google";
import { GOOGLE_CLIENT_ID } from "./Config"
import ReactGA from "react-ga4";
//import 'leaflet/dist/leaflet.css';
// 👉 1. Initialize Google Analytics (insert before rendering)
ReactGA.initialize('G-VHJQTCF272');  // Replace with your GA4 ID
ReactGA.send('pageview');  // Send initial pageview

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  // this StrictMode makes the useEffect to call self twice!
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <App />
  </GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
